import useSWR from 'swr';
import {
  EDataLookupStatus, EDataLookupType, IDataLookupListResponse,
} from 'types/data-lookup';

const activeStatuses = new Set([
  EDataLookupStatus.Requested,
  EDataLookupStatus.Processing,
]);

export const useDataLookups = (
  page: number,
  limit: number,
  lookupType = EDataLookupType.APNLookup,
) => {
  const { data, error, mutate } = useSWR<IDataLookupListResponse>(
    ['/data-lookups', { page, limit, lookupType }],
    {
      refreshInterval: (latestData) => (
        latestData?.data.some(({ status }) => activeStatuses.has(status)) ? 5000 : 0
      ),
    },
  );

  return {
    dataLookups: data?.data,
    pagination: data?.pagination,
    isLoading: !data && !error,
    error,
    mutate,
  };
};
